module.exports = __webpack_public_path__ + "img/05.ceb3f934.jpg";